import { render, staticRenderFns } from "./ShoppingCartItems.vue?vue&type=template&id=4d7c5b2a&"
import script from "./ShoppingCartItems.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartItems.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports